import { Menu } from '@mantine/core';
import { pluralize } from '@repo/common/utils';
import { Button } from '@repo/foundations';

export function QueryListLookbackDaysButton({
	lookBackDays,
	handleSetLookbackDays,
	options,
}: {
	lookBackDays: number;
	handleSetLookbackDays: (days: number) => void;
	options: number[];
}) {
	return (
		<Menu>
			<Menu.Target>
				<Button leftIconName="calendar" variant="primary">
					Last {lookBackDays} {pluralize('day', lookBackDays)}
				</Button>
			</Menu.Target>
			<Menu.Dropdown>
				{options.map((option) => (
					<Menu.Item key={option} onClick={() => handleSetLookbackDays(option)}>
						{option} {pluralize('day', option)}
					</Menu.Item>
				))}
			</Menu.Dropdown>
		</Menu>
	);
}
